/** @format */

import { DirectLine } from 'botframework-directlinejs';
import React, { useEffect, useMemo, useState } from 'react';
import { getFileNameFromPath } from '../helpers/StringOperations';
import './fileUploadCustomCard.css';
import { v4 as uuidv4 } from "uuid"
import { responsivePropType } from 'react-bootstrap/esm/createUtilityClasses';
//import 'bootstrap/dist/css/bootstrap.min.css';
//import 'https://cdn.jsdelivr.net/npm/bootstrap@4.3.1/dist/css/bootstrap.min.css';
interface FileUploadCardProps {
  Directline: DirectLine;
  Title: string;
  SubTitle: string;
  Variable: string;
}

export function FileUploadCustomCard(props: FileUploadCardProps) {
  const [fileName, setFileName] = useState<string>('');
  const [file, setFile] = useState<any>();
  const [myprops, setMyProps] = useState(props);
  const [variable, setVariable] = useState<string>(props.Variable);
  const [Show, setShow] = useState(false);
  const [tabledata, setTableData] = useState<string | null>(null);
  const unique_id = "label-file-upload-" + uuidv4();
  const unique_id_2 = "form-file-upload-" + uuidv4();

    // drag drop file component
    function DragDropFile() {
        // drag state
        const [dragActive, setDragActive] = React.useState(false);
        // ref
        const inputRef = React.useRef<HTMLInputElement>(null);

        useEffect(() => {
            tabletext();
        }, []);


        const tabletext = () => {
            let lang = window.location.pathname;
            let pathparts = lang.split('/');

            let country = pathparts.length >= 3 ? pathparts[1] : 'us';
            let locale = pathparts.length >= 3 ? pathparts[2] : 'en';

            if (country === null) country = 'us';
            if (locale === null) locale = 'en';

            //let responseText;

            fetch('/api/fileupload/productrecognition/2/' + locale, { method: 'GET' })
                .then(async (response) => {
                    let responseText = await getTextFromStream(response.body);
                    return responseText;
                })
                .then((responseText) => {
                    setTableData(responseText);
                });
        };
    

        // handle drag events
        const handleDrag = function (e: any) {
            e.preventDefault();
            e.stopPropagation();
            if (e.type === "dragenter" || e.type === "dragover") {
                setDragActive(true);
            } else if (e.type === "dragleave") {
                setDragActive(false);
            }
        };

        // triggers when file is dropped
        const handleDrop = function (e: any) {
            e.preventDefault();
            e.stopPropagation();
            setDragActive(false);
            if (e.dataTransfer.files && e.dataTransfer.files[0]) {
                
                setFile(e.dataTransfer.files[0]);
                setFileName(getFileNameFromPath(e.dataTransfer.files[0].name.toString()));
                               
                if (e.dataTransfer.files[0].name.toString().length > 0) {
                    setShow(true);                
                }
            }
            };
        
        // triggers when file is selected with click
        const handleChange = function (e: any) {
            setShow(false);
            e.preventDefault();
            e.stopPropagation();
            if (e.target.files && e.target.files[0]) {
                setFile(e.target.files[0]);
                setFileName(getFileNameFromPath(e.target.value.toString()));
                if (e.target.value.toString().length > 0) {
                    setShow(true);
                    e.target.value = '';
                }
            }
        };

        return (
            <form id={unique_id_2} onDragEnter={handleDrag} onSubmit={(e) => e.preventDefault()}>
                <input
                    accept=".jpg,.jpeg,.gif,.png,.tiff,.webp.,.bmp,.heif,.heic,.avif,.svg,.raw,.psd,.pdf,.eps,.ai"
                    ref={inputRef}
                    type="file"
                    title='file'   
                    className='bi'
                    id="input-file-upload"
                    multiple={false}
                    onChange={handleChange} />
                <label id={unique_id} htmlFor="input-file-upload" className={dragActive ? "drag-active" : ""}>
                    <div>
                        {!Show && <p>{tabledata}</p>}
                        {Show && <p>{fileName}</p>}
                    </div>
                </label>
                {dragActive && <div id="drag-file-element" onDragEnter={handleDrag} onDragLeave={handleDrag} onDragOver={handleDrag} onDrop={handleDrop}></div>}           
            </form>
        );
    };

    useEffect(() => {
        if (file) {
            handleSubmit();
            return;
        }
        else
        {
            return;
        }

        function handleSubmit() {
            var data = new FormData();
            data.append('file', file);
            fetch('/api/fileupload', { method: 'POST', body: data })
                .then(async (response) => {
                    let responseText = await getTextFromStream(response.body);
                    return responseText;
                })
                .then((responseText) => {
                    myprops.Directline.postActivity({
                        type: 'event',
                        name: 'setvariable:' + variable,
                        value: responseText,
                        from: {
                            id: 'abcdef',
                        },
                    })
                        .toPromise()
                        .then(() => {
                            myprops.Directline.postActivity({
                                type: 'message',
                                text: 'send',
                                from: {
                                    id: 'abcdef',
                                },
                            })
                                .toPromise()
                                .then(() => {
                                });
                        });
                });
        }
    }, [file, myprops.Directline, variable]);
    return (<div>{DragDropFile() }</div>  
  );
}

// helper function to properly read the contents from the fetched data
export const getTextFromStream  = async (
  readableStream: ReadableStream<Uint8Array> | null
) => {
  if (readableStream != null) {
    let reader = readableStream.getReader();
    let utf8Decoder = new TextDecoder();
    let nextChunk;

    let resultStr = '';

    while (!(nextChunk = await reader.read()).done) {
      let partialData = nextChunk.value;
      resultStr += utf8Decoder.decode(partialData);
    }

    return resultStr;
  } else {
    return 'bla';
  }
};
